import { render, staticRenderFns } from "./CardNumber.vue?vue&type=template&id=1b353012"
import script from "./CardNumber.vue?vue&type=script&lang=js"
export * from "./CardNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Counter: require('/srv/app/components/counter/Counter.vue').default})
